(() => {
  const desktop = matchMedia('(min-width: 990px)');
  const HEAD_TOP = 33; // the header's usual top padding
  let cleanup = () => {};
  function start() {
    cleanup();
    const header = document.querySelector('[data-ve-desktop-layout]');
    const page = header?.closest('.ve-page');
    if (!page || !desktop.matches) return;
    let frame = 0;
    // Hamburger + margins layout: where no menu group is open (Latest Drop), the margin shows the first group's
    // categories (Women), so the Filter is not alone there (BNJMN, 28 Oct)
    // (Men and other single links keep an empty margin: they have no categories of their own.)
    if (header.hasAttribute('data-ve-d6') && !header.querySelector('.ve-nav > .ve-nav__item > .ve-nav__sub:not([hidden])')) {
      const items = [...header.querySelectorAll('.ve-nav > .ve-nav__item')];
      const current = items.find(li => li.querySelector('[aria-current]'));
      if (!current || current === items[0]) {
        header.querySelector('.ve-nav > .ve-nav__item > .ve-nav__sub[hidden]')?.removeAttribute('hidden');
      }
    }
    const write = (key, value) => {
      const next = `${Math.round(value * 100) / 100}px`;
      if (page.style.getPropertyValue(key) !== next) page.style.setProperty(key, next);
    };
    const measure = () => {
      frame = 0;
      // Bottom padding (BNJMN, 23 Oct): the page starts under the logo row (top padding + logo height +
      // bottom padding). Set first, so the card measured below is already in its final place.
      if (header.hasAttribute('data-ve-desktop-v2')) {
        const v = getComputedStyle(header);
        const logoH = header.querySelector('.ve-bar__logo-wrap').getBoundingClientRect().height;
        write('--ve-desktop-main-top', (parseFloat(v.getPropertyValue('--ve-top-pad')) || 0) + logoH + (parseFloat(v.getPropertyValue('--ve-bottom-pad')) || 0));
      }
      const card = page.querySelector('.product-grid > .grid__item');
      const image = card?.querySelector('.card__inner');
      const heading = page.querySelector('.template-search__header h1');
      const cart = header.querySelector('.ve-bar__cart');
      const facets = page.querySelector('#main-collection-filters');
      // Ignore entrance translations on both cards and their grid container.
      // Right-menu layout, search with no results: no photo to follow, so the menu and Cart start where the first photo would (18px under the path line)
      const pathRow = header.hasAttribute('data-ve-side') ? page.querySelector('.ve-search-path') : null;
      let imageTop = image ? image.getBoundingClientRect().top + scrollY : (pathRow ? pathRow.getBoundingClientRect().bottom + scrollY + 18 : 100);
      for (let node = image; node && node !== page; node = node.parentElement) {
        if (node.classList.contains('scroll-trigger')) {
          const transform = getComputedStyle(node).transform;
          if (transform !== 'none') imageTop -= new DOMMatrixReadOnly(transform).m42;
        }
      }
      // Menu categories: the row of picked categories sits above the first card. The fixed menu and Filter stay
      // level with the first card, so they move down with it when the row appears (BNJMN, 26 Oct; before, they
      // stayed at the row's height).
      const row = cart.getBoundingClientRect().height + 4;
      // the right-menu layout (data-ve-side) places the menu on search results exactly as on collections
      const search = header.dataset.veDesktopLayout === 'search' && !header.hasAttribute('data-ve-side');
      // Collections: menu and Cart start a tenth of the way down the first photo (BNJMN, 19 Oct, from his
      // screenshot; name and price not counted)
      const menuTop = search ? imageTop : imageTop + (image?.getBoundingClientRect().height || 240) / 10;
      write('--ve-desktop-top', imageTop);
      write('--ve-desktop-menu-top', menuTop);
      // Search results: Search sits up with the logo, so Cart takes its place on the first-photo line.
      write('--ve-desktop-controls-top', menuTop);
      write('--ve-desktop-row', row);
      write('--ve-desktop-end', parseFloat(getComputedStyle(header.querySelector('.ve-bar__utils')).insetInlineEnd) || 0);
      const facetsHeight = facets?.getBoundingClientRect().height || 0;
      write('--ve-desktop-facets-space', facetsHeight ? facetsHeight + 4 : 0);
      // Logo and Search up top (BNJMN, 19 Oct): the Search line sits level with the logo's bottom.
      // Collections and Latest Drop: logo 33px from the top. Search results: logo bottom = heading bottom.
      const logo = header.querySelector('.ve-bar__logo-wrap');
      const searchBox = header.querySelector('.ve-bar__start .ve-compact-search--header form');
      const logoHeight = logo.getBoundingClientRect().height;
      // Search results (BNJMN, 20 Oct): the logo stays 33px from the top; the heading row starts so that,
      // with the section's top padding at 0, its bottom is level with the logo's bottom. The padding then
      // adds a gap between the logo / Search line and the heading, photos, menu and Cart.
      const logoTop = HEAD_TOP;
      if (search && heading) {
        write('--ve-search-heading-space', Math.max(0, logoHeight - heading.getBoundingClientRect().height));
      }
      write('--ve-desktop-logo-top', logoTop);
      // Search results: the line level with the logo's bottom. Collections: Search mirrors the logo,
      // its top level with the logo's top (BNJMN, 19 Oct).
      if (searchBox) write('--ve-desktop-search-top', search ? logoTop + logoHeight - searchBox.getBoundingClientRect().height : logoTop);
      // Collection and search pages, computers (BNJMN, 23 Oct; header attribute data-ve-desktop-v2): logo at the
      // Header's "Top padding"; Search · Favorites · Cart in one row whose line under Search sits at
      // "Search line height on the logo" (% of the logo height, 46 = under "Violet"); menu and Filter start at
      // the top of the first card.
      if (header.hasAttribute('data-ve-desktop-v2')) {
        const vars = getComputedStyle(header);
        const topPad = parseFloat(vars.getPropertyValue('--ve-top-pad')) || 0;
        const pct = parseFloat(vars.getPropertyValue('--ve-line-pct'));
        const lineY = topPad + logoHeight * (Number.isFinite(pct) ? pct : 46) / 100;
        const utils = header.querySelector('.ve-bar__utils');
        const utilsBox = utils.getBoundingClientRect();
        write('--ve-desktop-logo-top', topPad);
        write('--ve-desktop-menu-top', imageTop);
        write('--ve-desktop-controls-top', imageTop);
        // Hamburger + margins layout: Filter sits under Cart and Favorites in the right margin
        // Hamburger + margins layout: Filter sits under Cart and Favorites in the right margin
        if (header.hasAttribute('data-ve-d6')) write('--ve-d6-filter-top', imageTop + 15 + utilsBox.height + 18);
        // Hamburger + margins layout (BNJMN, 28 Oct): the hamburger button's centre is the logo's centre, at any logo size
        // and any value of the up / down slider (24px = the button's height)
        if (header.hasAttribute('data-ve-d6')) {
          const logoY = parseFloat(vars.getPropertyValue('--ve-collection-logo-y')) || 0;
          write('--ve-d6-burger-top', topPad + logoHeight / 2 + logoY - 12);
        }
        write('--ve-desktop-utils-top', lineY - utilsBox.height);
        write('--ve-desktop-utils-w', utilsBox.width);
        if (searchBox) write('--ve-desktop-search-top', lineY - searchBox.getBoundingClientRect().height);
      }
    };
    // Hamburger + margins layout: the categories and Filter fade out (the line above Filter erases itself) while
    // scrolling down, and come back the moment the visitor scrolls up, or once the page has been still for 1.5 seconds (BNJMN, 28 Oct)
    let lastY = scrollY;
    let idle = 0;
    const returnLater = () => {
      clearTimeout(idle);
      idle = setTimeout(() => header.classList.remove('is-scrolled'), 1500);
    };
    const onScroll = () => {
      const y = scrollY;
      if (y <= 40) {
        clearTimeout(idle);
        header.classList.remove('is-scrolled');
      } else if (y > lastY + 4) {
        header.classList.add('is-scrolled');
        returnLater();
      } else if (y < lastY - 4) {
        // scrolling up: back at once
        clearTimeout(idle);
        header.classList.remove('is-scrolled');
      }
      lastY = y;
    };
    if (header.hasAttribute('data-ve-d6') || header.hasAttribute('data-ve-side')) addEventListener('scroll', onScroll, { passive: true });
    const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
    const resize = new ResizeObserver(schedule);
    resize.observe(page.querySelector('main'));
    resize.observe(header.querySelector('.ve-bar__utils'));
    const facets = page.querySelector('#main-collection-filters');
    if (facets) resize.observe(facets);
    const sideNav = header.querySelector('.ve-side .ve-nav');
    if (sideNav) resize.observe(sideNav);
    const mutation = new MutationObserver(schedule);
    mutation.observe(page.querySelector('main'), { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
    page.addEventListener('load', schedule, true);
    page.addEventListener('animationend', schedule, true);
    document.fonts.ready.then(schedule);
    schedule();
    cleanup = () => {
      resize.disconnect();
      mutation.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      removeEventListener('scroll', onScroll);
      clearTimeout(idle);
      header.classList.remove('is-scrolled');
      page.removeEventListener('load', schedule, true);
      page.removeEventListener('animationend', schedule, true);
      [...page.style].filter(key => key.startsWith('--ve-desktop-') || key === '--ve-d6-filter-top' || key === '--ve-search-heading-space').forEach(key => page.style.removeProperty(key));
    };
  }
  desktop.addEventListener('change', start);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
